import { MapPin } from 'lucide-react';

export function LocationsTab({ locations }) {
  if (locations.length === 0) return <div className="bg-white rounded-xl border border-gray-200 p-12 text-center"><MapPin className="w-12 h-12 text-gray-300 mx-auto mb-4" /><p className="text-gray-500">No locations on file</p></div>;
  return (
    <div className="grid grid-cols-2 gap-4">
      {locations.map(loc => (
        <div key={loc.id} className="bg-white rounded-xl border border-gray-200 p-6">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-[#84CC16]/10 rounded-xl flex items-center justify-center flex-shrink-0"><MapPin className="w-5 h-5 text-[#84CC16]" /></div>
            <div>
              <h3 className="font-bold text-[#0A1628]">{loc.name}</h3>
              <p className="text-sm text-gray-600">{loc.address}</p>
              <p className="text-sm text-gray-600">{loc.city}, {loc.state} {loc.zip_code}</p>
              {loc.phone && <p className="text-sm text-gray-500 mt-1">{loc.phone}</p>}
              {loc.is_primary && <span className="inline-block mt-2 px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs font-semibold">Primary</span>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
